import { useQuery } from "@tanstack/react-query";
import { memberType } from "./query";
import { PostModel } from "common/models/BaseModel";
import { IMemberTypeGridFilter } from "./types";

export function GetMemberTypes(
  model: PostModel<IMemberTypeGridFilter> | undefined
) {
  return useQuery(memberType.list(model));
}

export function GetMemberType(Id: string | number | undefined) {
  return useQuery({
    ...memberType.getById(Id || ""),
    enabled: Boolean(Id),
  });
}

export function GetMemberTypeValues() {
  return useQuery({
    ...memberType.getMemberTypeValues(),
    refetchOnMount: true,
  });
}

export function GetMemberTypeView(id: string | number | undefined, isOpen: boolean) {
  return useQuery({
    ...memberType.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}

export function CheckForMember(Id: string | number | undefined) {
  return useQuery({
    ...memberType.checkForMember(Id),
    enabled: Boolean(Id),
  });
}
